import CrudActions, { ICrudActions } from 'src/actions/helpers/CrudActions'

const actions: ICrudActions = CrudActions({
  entityName: 'accountUser',
  collectionName: 'accountUsers'
})

export default actions
